import { takeLatest, call, put, select } from "redux-saga/effects";
import {
  SEARCH_CITY_BOUNDS,
  setBounds,
  setCityName,
  setCityBounds,
  setErrorToastMessage,
  SEARCH_AREA_BOUNDS
} from "../actions";
import { searchBounds } from "../../../api/geofence/google-maps";

export function* searchCityBoundsTask(action) {
  try {
    const bounds = yield call(searchBounds, action.payload);
    yield put(setCityName(action.payload));
    yield put(setCityBounds(bounds));
    yield put(setBounds(bounds));
  } catch (e) {
    yield put(setErrorToastMessage(e.message));
  }
}

export function* watchSearchCityBound() {
  yield takeLatest(SEARCH_CITY_BOUNDS, searchCityBoundsTask);
}

export function* searchAreaBoundsTask(action) {
  try {
    const cityName = yield select(({ geofence }) => geofence.currentCityName);

    // Narrow search to Current selected city
    const bounds = yield call(searchBounds, `${action.payload} ${cityName}`);
    yield put(setBounds(bounds));
  } catch (e) {
    yield put(setErrorToastMessage(e.message));
  }
}

export function* watchSearchAreaBound() {
  yield takeLatest(SEARCH_AREA_BOUNDS, searchAreaBoundsTask);
}
